import NextImage, { ImageProps, ImageLoaderProps } from 'next/image'
import { imagesPath } from 'utils/path'

/**
 * Loader to resolver src, width, and quality for image component
 * Will overide nextjs default loader
 */
const customLoader = ({ src, width, quality }: ImageLoaderProps) =>
  `${imagesPath}/${src}?w=${width}&q=${quality || 100}`

/**
 * This component is to opt-out nextjs built in image optimization
 * This is to enable nextjs static HTML export
 */
const Image = (props: ImageProps) => {
  return <NextImage {...props} loader={customLoader} />
}

export default Image
